import { IconButton, Switch, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { Header } from "../global/Header";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState } from "react";
import { useEffect } from "react";
import { format } from "date-fns";
import {
  GoogleMap,
  InfoWindow,
  InfoWindowF,
  Marker,
  MarkerF,
  useLoadScript,
} from "@react-google-maps/api";
import BASE_URL from "../../NetworkConfig/ApiConfig";
import { utcToZonedTime } from "date-fns-tz";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
const CommunityUserActivity = () => {
  let query = useQuery();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [UserState, setUserState] = useState(null);
  const [imageno, setimageno] = useState(0);
  const [currentTab, setCurrentTab] = useState(0)
  const [error, seterror] = useState("Loading.....");
  const isMobileScreen = useMediaQuery('(max-width:500px)');
  const isTabScreen = useMediaQuery('(max-width:1200px)')
  const [isInvalid, setIsInvalid] = useState(false)
  const [activity, setActivity] = useState({})
  const [totalTime, setTotalTime] = useState(0)
  const [todayTime, setTodayTime] = useState(0)
  const [overallActivity, setOverallActivity] = useState({})
  const [populatedData, setPopulatedData] = useState({
    success: false,
    users: [],
    clubs: [],
    events: [],
    groups: []
  })



  const FetchUserDetails = async () => {
    // setloading(true);
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/community/useractivity/${query.get("userid")}?communityId=${query.get("community")}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
    });
    const data = await response.json();
    console.log(data)
    if (data.success === true) {
      setUserState(data.response);
      setIsInvalid(data.invalid)
      setActivity(data.activity)
      setTotalTime(data.totalTimeSpent)
      setTodayTime(data.todayTimeSpent)
      const allActivity = mergeActivityFromApi(data.activity.activity)
      setOverallActivity(allActivity)
      GetDetailsByIds(allActivity)
      return;
    }
    if (data.success === false) {
      seterror(data.response);
    }
  };



  const extractMongoUsersId = (key) => {
    const match = key.match(/^Community_Profile_(\w{24})$/);
    return match ? match[1] : null;
  };

  const extractMongoClubsId = (key) => {
    const match = key.match(/^Club_Page_(\w{24})$/);
    return match ? match[1] : null;
  };

  const extractMongoProfileFollowersId = (key) => {
    const match = key.match(/^Community_Profile_Followers_(\w{24})$/);
    return match ? match[1] : null;
  };

  const extractMongoGroupsId = (key) => {
    const match = key.match(/^Group_Chat_(\w{24})$/);
    return match ? match[1] : null;
  };

  const extractMongoEventsId = (key) => {
    const match = key.match(/^Event_Detail_(\w{24})$/);
    return match ? match[1] : null;
  };

  const extractMongoSeriesDetailId = (key) => {
    const match = key.match(/^Series_Detail_Page_(\w{24})$/);
    return match ? match[1] : null;
  };

  const extractMongoClubFollowersId = (key) => {
    const match = key.match(/^Club_Followers_(\w{24})$/);
    return match ? match[1] : null;
  };

  const extractMongoEpisodesPlaybackId = (key) => {
    const match = key.match(/^Episode_Playback_(\w{24})$/);
    return match ? match[1] : null;
  };

  const extractMongoProductsId = (key) => {
    const match = key.match(/^Product_Detail_(\w{24})$/);
    return match ? match[1] : null;
  };


  const extractMongoCollabId = (key) => {
    const match = key.match(/^Collab_Detail_(\w{24})$/);
    return match ? match[1] : null;
  };



  const get_all_ids = async (data) => {

    const userIds = new Set([])
    const clubIds = new Set([])
    const eventIds = new Set([])
    const groupIds = new Set([])


    Object.entries(data)
      .map(([key, value]) => {
        if (key.startsWith("Community_Profile_Followers_")) {
          userIds.add(extractMongoProfileFollowersId(key))
        } else if (key.startsWith("Community_Profile_")) {
          userIds.add(extractMongoUsersId(key))
        } else if (key.startsWith("Club_Page_")) {
          clubIds.add(extractMongoClubsId(key))
        } else if (key.startsWith("Club_Followers_")) {
          clubIds.add(extractMongoClubFollowersId(key))
        } else if (key.startsWith("Event_Detail_")) {
          eventIds.add(extractMongoEventsId(key))
        } else if (key.startsWith("Group_Chat_")) {
          groupIds.add(extractMongoGroupsId(key))
        }
        return
      })

    return { userIds, clubIds, eventIds, groupIds }


  }



  const GetDetailsByIds = async (activity) => {

    const ids_to_post = await get_all_ids(activity)
    // setloading(true);
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/community/getdatabyids`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
      body: JSON.stringify({
        userIds: [...ids_to_post.userIds],
        clubIds: [...ids_to_post.clubIds],
        eventIds: [...ids_to_post.eventIds],
        groupIds: [...ids_to_post.groupIds]
      })
    });
    const data = await response.json();
    console.log(data)
    if (data.success === true) {
      setPopulatedData(data)
      return;
    }
    if (data.success === false) {
      seterror(data.response);
    }
  };

  useEffect(() => {
    FetchUserDetails();
  }, []);


  const getTodayActivityDetails = () => {
    const Datenow = new Date().toISOString();
    const timeZone = "Asia/Kolkata"
    const zonedDate = utcToZonedTime(Datenow, timeZone);
    const istTime = format(zonedDate, "yyyy-MM-dd", { timeZone });
    return activity.activity[`${istTime}`] || {}
  }


  const mergeActivityFromApi = (activity) => {
    const merged = {};

    Object.values(activity).forEach(day => {
      for (const [key, value] of Object.entries(day)) {
        if (!merged[key]) {
          merged[key] = { count: 0, timeSpent: 0 };
        }

        merged[key].count += value.count;
        merged[key].timeSpent += value.timeSpent;
      }
    });

    return merged;
  };

  const formatTime = (seconds) => {
    if (seconds < 60) {
      return `${seconds.toFixed(0)}s`;
    }

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    if (minutes < 60) {
      return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds.toFixed(0)}s` : `${minutes}m`;
    }

    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours < 24) {
      return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
    }

    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;

    return remainingHours > 0
      ? `${days}d ${remainingHours}h ${remainingMinutes}m`
      : `${days}d ${remainingHours}h`;
  };


  const getDocument = (id) => {
    const arr = [...populatedData.clubs, ...populatedData.events, ...populatedData.groups, ...populatedData.users]
    const data = arr.find(key => key._id == id)
    if (data) {
      return data
    } else {
      return null
    }
  }
  const extractReadableLabel = (key) => {
    const match = key.match(/^(.+?)_([a-f\d]{24})$/i);
    const raw = match ? match[1] : key;
    return raw.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

  const hasIds = (key) => {

    if (key.startsWith("Community_Profile_") || key.startsWith("Community_Profile_Followers_")
      || key.startsWith("Club_Followers_") || key.startsWith("Event_Detail_") ||
      key.startsWith("Club_Page_") || key.startsWith("Group_Chat_")
    ) {
      return true
    } else {
      return false
    }
  };

  const extractPrefixAndId = (key) => {
    const match = key.match(/^(.+?)_([a-f\d]{24})$/i);
    return match ? { prefix: match[1], id: match[2] } : null;
  };


  const idExists = (key) => {
    const idTocheck = extractPrefixAndId(key)
    const allArr = [...populatedData.clubs, ...populatedData.events, ...populatedData.groups, ...populatedData.users]
    return allArr.some(doc => doc._id == idTocheck.id)
  };


  if (!UserState) {
    return <Box>{error}</Box>;
  }


  return (
    <>
      <Box m={(isMobileScreen || isTabScreen) ? "0px" : "20px"} flexDirection={(isMobileScreen || isTabScreen) ? "column" : 'row'} display={"flex"} flexWrap={'wrap'} backgroundColor={(isMobileScreen || isTabScreen) ? "#00000000" : "#ffffff05"} sx={{ paddingX: "25px", paddingY: "25px", borderRadius: "20px" }} >

        {/* left container */}
        <Box sx={{
          flexDirection: 'column', flex: 1,
          borderRight: (isMobileScreen || isTabScreen) ? "none" : "1px solid #ffffff10", marginRight: (isMobileScreen || isTabScreen) ? "0px" : "10px"
        }}>

          <Box sx={{ flexDirection: 'row', display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>

            <img
              width={"90px"}
              height={"90px"}
              src={UserState["userId"]["image"][0]}
              style={{ borderRadius: "50%", border: "6px solid #aaaaaa10", objectFit: 'cover' }}
            />

            <Box sx={{ flexDirection: 'column', marginLeft: "15px" }} flex={1}>
              <Box sx={{
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: "center",
                alignContent: 'center',
                justifyItems: 'center',
                display: 'flex'
              }}><Typography style={{
                fontFamily: 'poppins-mid',
                fontSize: "20px"
              }}>{UserState["userId"]["full_name"]}</Typography>
                <Typography style={{
                  borderRadius: "50px",
                  paddingLeft: '10px',
                  paddingRight: "10px",
                  backgroundColor: "#ffffff10",
                  fontFamily: 'poppins-reg',
                  fontSize: "13px",
                  marginLeft: "10px",
                  color: "#ffffff"
                }} >{UserState["userId"]["buzz_name"]}</Typography>
              </Box>

              <Box sx={{
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: "flex-start",
                marginTop: "5px",
                display: 'flex'
              }}>



                <Typography style={{
                  borderRadius: "3px",
                  border: "1px solid #ffffff30",
                  paddingLeft: '6px',
                  paddingRight: "6px",
                  alignSelf: 'flex-start',
                  fontFamily: 'poppins-reg',
                  fontSize: "13px",
                  marginRight: '5px',
                  color: "#ffffff"
                }} >{UserState["userId"]["gender"]}</Typography>


                <Typography style={{
                  borderRadius: "3px",
                  border: `1px solid ${UserState["userId"]["Active"] ? "#07d10020" : "#ffffff20"}`,
                  paddingLeft: '6px',
                  paddingRight: "6px",
                  backgroundColor: UserState["userId"]["Active"] ? "#07d10030" : "#ffffff30",
                  alignSelf: 'flex-start',
                  fontFamily: 'poppins-reg',
                  fontSize: "13px",
                  marginRight: "5px",
                  color: UserState["userId"]["Active"] ? "#07d100" : "#aaaaaa"
                }} >{UserState["userId"]["Active"] ? "• Active" : "Not Active"}</Typography>

                {
                  isInvalid && UserState["userId"]["Active"] && (
                    <Typography style={{
                      borderRadius: "3px",
                      border: `1px solid #ff220020`,
                      paddingLeft: '6px',
                      paddingRight: "6px",
                      backgroundColor: "#ff220030",
                      alignSelf: 'flex-start',
                      fontFamily: 'poppins-reg',
                      fontSize: "13px",
                      color: "#ff2200"
                    }}>Uninstalled</Typography>
                  )
                }





              </Box>
              <Typography style={{
                fontFamily: 'poppins-reg',
                fontSize: "13px",
                color: "#ffffff70",
                marginTop: "10px",
              }}>{`Buzz user ${UserState["userId"]["createdAt"]
                ? "since " +
                format(new Date(UserState["userId"]["createdAt"]), "MMM dd, yyyy hh:mma")
                : `since ${format(new Date("March 7, 2023"), "MMM dd, yyyy hh:mma")}`
                }`}</Typography>
            </Box>

            <Typography style={{
              borderRadius: "3px",
              border: "1px solid #ffffff10",
              paddingLeft: '6px',
              paddingRight: "6px",
              paddingBottom: "3px",
              paddingTop: "3px",
              alignSelf: 'flex-start',
              fontFamily: 'poppins-reg',
              fontSize: "13px",
              marginTop: "5px",
              marginLeft: '5px',
              marginRight: "20px",
              cursor: 'pointer',
              color: "#ffffff70"
            }} >❐ {UserState["userId"]["_id"]}</Typography>

          </Box>

          <Box sx={{ maxWidth: "300px", marginTop: "20px", height: "1px", backgroundColor: "#ffffff10" }} />

          <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", marginTop: "20px", marginLeft: "5px" }} >Community Mail</Typography>
          <Typography style={{ fontFamily: "poppins-reg", fontSize: "16px", color: "#ffffff", marginLeft: "5px" }} >{UserState["communityMail"]}</Typography>
          <Box sx={{ maxWidth: "300px", marginTop: "25px", height: "1px", backgroundColor: "#ffffff10" }} />

          <Box
            display={"grid"}
            flex={1}
            gridTemplateColumns="repeat(12,1fr)"
            gridAutoRows={"auto"}
            paddingRight={"10px"}
            gap="20px"
          >

            <Box
              gridColumn="span 4"
              gridRow="span 2"
              overflow="auto"
            >
              <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", marginTop: "20px", marginLeft: "5px" }} >Followers</Typography>
              <Typography style={{ fontFamily: "poppins-mid", fontSize: "16px", color: "#ffffff", marginLeft: "5px" }} >{UserState["followers"].length}</Typography>
            </Box>

            <Box
              gridColumn="span 4"
              gridRow="span 2"
              overflow="auto"
            >
              <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", marginTop: "20px", }} >Followings</Typography>
              <Typography style={{ fontFamily: "poppins-mid", fontSize: "16px", color: "#ffffff", }} >{UserState["followings"].length}</Typography>
            </Box>

            <Box
              gridColumn="span 4"
              gridRow="span 2"
            >
              <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", marginTop: "20px", }} >Is Influencer</Typography>
              <Typography style={{ fontFamily: "poppins-mid", fontSize: "16px", color: "#ffffff", wordBreak: 'break-all' }} >{`${UserState["isInfluancer"]}`}</Typography>
            </Box>


            <Box
              gridColumn="span 4"
              gridRow="span 2"
              overflow="auto"
            >
              <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", marginLeft: "5px" }} >Joined Community</Typography>
              <Typography style={{ fontFamily: "poppins-mid", fontSize: "16px", color: "#ffffff", marginLeft: "5px" }} >{format(new Date(UserState["createdAt"]), "MMM dd, yyyy hh:mma")}</Typography>
            </Box>

            <Box
              gridColumn="span 4"
              gridRow="span 2"
              overflow="auto"
            >
              <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", }} >Country</Typography>
              <Typography style={{ fontFamily: "poppins-mid", fontSize: "16px", color: "#ffffff", }} >{(UserState["userId"]["country"] == "" || UserState["userId"]["country"] == "_") ? "NA" : UserState["userId"]["country"]}</Typography>
            </Box>
            <Box
              gridColumn="span 4"
              gridRow="span 2"
              overflow="auto"
            >
              <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", }} >City</Typography>
              <Typography style={{ fontFamily: "poppins-mid", fontSize: "16px", color: "#ffffff", }} >{(UserState["userId"]["city"] == "" || UserState["userId"]["city"] == "_") ? "NA" : UserState["userId"]["city"]}</Typography>
            </Box>

            <Box
              gridColumn="span 12"
              gridRow="span 2"
              overflow="auto"
            >
              <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", marginLeft: "5px" }} >Profession</Typography>
              <Typography style={{ fontFamily: "poppins-mid", fontSize: "16px", color: "#ffffff", marginLeft: "5px", wordBreak: 'break-all' }} >{UserState["userId"]["profession"] || "NA"}</Typography>
            </Box>
          </Box>

          <Box sx={{ maxWidth: "300px", marginTop: "25px", height: "1px", backgroundColor: "#ffffff10" }} />
          <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", marginLeft: '5px', marginTop: "20px" }} >Interest in {UserState["userId"]["interests"].length} topics</Typography>
          <Box
            // backgroundColor={colors.primary[400]}
            alignItems={"center"}
            display={'flex'}
            // justifyContent="space-around"
            justifyContent={"flex-start"}
            sx={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              marginTop: UserState["userId"]["interests"].length > 0 ? "10px" : "0px",
              marginLeft: '5px'
            }}
          >
            {UserState["userId"]["interests"].map((text, index) => (
              <Typography style={{
                borderRadius: "3px",
                border: "1px solid #ffffff30",
                paddingLeft: '9px',
                backgroundColor: "#ffffff10",
                paddingRight: "9px",
                alignSelf: 'flex-start',
                fontFamily: 'poppins-reg',
                fontSize: "14px",
                marginRight: '5px',
                paddingTop: "3px",
                paddingBottom: "3px",
                color: "#ffffff"
              }} >{text}</Typography>

            ))}


          </Box>
          <Box sx={{ maxWidth: "300px", marginTop: "25px", height: "1px", backgroundColor: "#ffffff10" }} />

          <Typography style={{ fontFamily: "poppins-reg", fontSize: "14px", color: "#ffffff60", marginLeft: '5px', marginTop: "20px" }} >{UserState["userId"]["image"].length} Photos Added</Typography>

          <Box
            // backgroundColor={colors.primary[400]}
            alignItems={"center"}
            display={'flex'}
            // justifyContent="space-around"
            justifyContent={"flex-start"}
            sx={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              marginLeft: '5px'
            }}
            mb={2}
          >
            {UserState["userId"]["image"].map((link, index) => (
              <img
                key={index}
                alt="profile-user"
                width="110px"
                height="150px"
                src={link}
                style={{
                  marginRight: "10px", marginTop: "10px", cursor: "pointer", borderRadius: "10px", padding: "5px", objectFit: "cover",
                  backgroundColor: "#ffffff10"
                }}
              />

            ))}

          </Box>

        </Box>
        {/* right container */}
        <Box sx={{
          flexDirection: 'column', flex: 1,
          overflow: 'hidden',
          flexFlow: 'wrap'
        }}>


          <Typography style={{ fontFamily: 'poppins-mid', fontSize: "16px", marginBottom: "10px", color: "#aaaaaa", marginTop: (isMobileScreen || isTabScreen) ? "30px" : "0px" }} >{UserState["userId"]["full_name"]} activity in community</Typography>

          <Box
            display={"grid"}
            flex={1}
            gridTemplateColumns="repeat(12,1fr)"
            gridAutoRows={"auto"}
            paddingRight={"10px"}
            gap="20px"
            sx={{ flexDirection: 'column', display: 'flex' }}
          >

            {

              Object.entries(overallActivity)
                .sort(([, a], [, b]) => b.count - a.count) // sort by count descending
                .map(([key, value]) => {
                  // your list code here

                  return (
                    <Box sx={{
                      flexDirection: 'column', display: 'flex', background: "#ffffff05", border: "0px solid #ffffff10", paddingBlock: "10px",
                      paddingInline: "10px", borderRadius: "8px"
                    }}>

                      <Typography style={{ fontFamily: 'poppins-reg', fontSize: "12px", marginBottom: "10px", color: "#ffffff" }}>{extractReadableLabel(key)}</Typography>


                      <Box
                        // key={`${transaction.txId}-${i}`}
                        display="flex"
                        alignItems="center"
                        target={"_blank"}
                        sx={{
                          flexDirection: 'row',
                          marginTop: "0px",
                          display: 'flex',
                        }}>

                        <Box sx={{
                          flex: 1, flexDirection: 'row', display: 'flex', paddingInline: "10px", background: "#ffffff08",
                          borderRadius: "10px",
                          border: "0px solid #ffffff10",
                          textDecoration: 'none', paddingY: "8px",
                        }}>

                          <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', }}>

                            <Typography fontSize={"11px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                              Total Time
                            </Typography>

                            <Box sx={{
                              flexDirection: 'row', display: "flex", alignItems: 'center', marginTop: "2px"
                            }}>

                              <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "0 0 0 0", display: 'flex' }}>
                                <Typography
                                  fontSize={"14px"}
                                  color={colors.grey[100]}
                                  fontFamily={"poppins-reg"}
                                >
                                  {formatTime(value.timeSpent)}
                                </Typography>

                              </Box>

                              <Typography fontSize={"10px"} sx={{
                                background: "#ffffff20", borderRadius: "3px", paddingInline: "6px",
                                marginLeft: "10px", border: "0.5px solid #ffffff10"
                              }}
                                fontFamily={'poppins-reg'} color={"#ffffff"}>
                                {value.count}
                              </Typography>
                            </Box>

                          </Box>

                          <Box sx={{ width: "1px", background: "#ffffff10", marginInline: "20px" }} />

                          <Box sx={{ flex: 1, flexDirection: 'column', display: 'flex', }}>

                            <Typography fontSize={"11px"} fontFamily={'poppins-reg'} color={colors.grey[300]}>
                              Today
                            </Typography>

                            <Box sx={{
                              flexDirection: 'row', display: "flex", alignItems: 'center', marginTop: "2px"
                            }}>

                              <Box sx={{ flexDirection: 'row', alignItems: 'center', m: "0 0 0 0", display: 'flex' }}>
                                <Typography
                                  fontSize={"14px"}
                                  color={getTodayActivityDetails()[key] ? "orange" : "#aaaaaa"}
                                  fontFamily={"poppins-reg"}
                                >
                                  {getTodayActivityDetails()[key] ? formatTime(getTodayActivityDetails()[key].timeSpent) : "-"}
                                </Typography>

                              </Box>

                              {
                                getTodayActivityDetails()[key] && (
                                  <Typography fontSize={"10px"} sx={{
                                    background: "#ffffff20", borderRadius: "3px", paddingInline: "6px",
                                    marginLeft: "10px", border: "0.5px solid #ffffff10"
                                  }}
                                    fontFamily={'poppins-reg'} color={"#ffffff"}>
                                    {getTodayActivityDetails()[key].count}
                                  </Typography>
                                )
                              }


                            </Box>

                          </Box>






                        </Box>

                      </Box>

                      {
                        hasIds(key) && idExists(key) && (() => {

                          const prefix_id = extractPrefixAndId(key)
                          const doc = getDocument(prefix_id.id);
                          const imageSrc =
                            (Array.isArray(doc?.image) && doc.image[0]) ||
                            doc?.clubLogo ||
                            doc?.thumbnail ||
                            doc?.image ||
                            doc?.logo ||
                            doc?.banner;

                          const name =
                            doc?.full_name ||
                            doc?.title

                          const type = doc?.logo ? "group" : doc?.banner ? "event" : doc?.clubLogo ? "club" : "user"


                          return (
                            <Box
                            component={type === "user" ? Link : "div"}
                            to={{
                              pathname: "/admin/community/user/activity",
                              search: `?userid=${doc?._id}&community=${query.get('community')}`,
                              state: { fromDashboard: true },
                            }}
                            target={type === "user" ? "_blank" : undefined}
                            rel={type === "user" ? "noopener noreferrer" : undefined}

                              sx={{
                                flexDirection: 'row', alignItems: 'center', display: 'flex', marginTop: "10px", background: "#ffffff10", alignSelf: 'flex-start',
                                paddingInline: "10px", paddingBlock: "8px", borderRadius: "8px", textDecoration: 'none'
                              }}>
                              <Box sx={{ width: "30px", height: "30px", borderRadius: "100px", background: "#ffffff", overflow: 'hidden', marginRight: "10px" }}>
                                <img style={{ width: "100%", height: "100%", objectFit: "contain" }} src={imageSrc} />
                              </Box>

                              <Box sx={{ flexDirection: 'column', display: 'flex' }}>
                                <Typography style={{ fontFamily: 'poppins-reg', fontSize: "12px", color: "#ffffff" }}>{name}</Typography>
                                <Typography style={{
                                  fontFamily: 'poppins-reg', fontSize: "10px", color: "#ffffff80", marginTop: "2px", paddingInline: "5px", paddingBlock: "0px", background: "#ffffff10",
                                  border: "1px solid #ffffff20", borderRadius: "4px",
                                  alignSelf: "flex-start"
                                }}>{type}</Typography>
                              </Box>

                            </Box>
                          );
                        })()
                      }


                      <Box>

                      </Box>

                    </Box>
                  )

                })
            }




          </Box>

        </Box>

      </Box>

    </>
  );
};

export default CommunityUserActivity;
